import React from "react";
import "./style/content.css";

function Header() {
  return (
    <header className="hero-wrap">
      {/* Background Shapes */}
      <div className="bg-shape shape-left"></div>
      <div className="bg-shape shape-right"></div>
      <div className="blur-circle circle-1"></div>
      <div className="blur-circle circle-2"></div>
      <div className="blur-circle circle-3"></div>
      <div className="blur-circle circle-4"></div>



      {/* Content */}
      <div className="hero-content" id="home">
        <h1 className="hero-title">
          From <span className="highlight">Models</span>
          <br />To Movements
        </h1>
        <p className="hero-subtitle">
          We don't just follow trends, we create creative solutions that are relevant and impactful to your business.
        </p>

        <div className="cta-buttons">
          <a href="#why-us" className="btn-primary">
            Get Started
          </a>
          <a href="#portofolio" className="btn-outline">
            Portofolio →
          </a>
        </div>
      </div>
    </header>
  );
}

export default Header;
